import { render, staticRenderFns } from "./CoursewareUnitItem.vue?vue&type=template&id=1598bb98&"
import script from "./CoursewareUnitItem.vue?vue&type=script&lang=js&"
export * from "./CoursewareUnitItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports